module.exports = __webpack_public_path__ + "img/x3.2542efea.jpg";